import styled from 'styled-components'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import PcChart from './PcChart'
import { useEffect, useState } from 'react'
import * as d3 from 'd3'
import { Small, ContentWidth } from '../../theme/styles'
// import { throttle } from 'throttle-debounce'

const WomenChart = () => {
  const [step, setStep] = useState<number>(0)
  const [data, setData] = useState<WomenData[]>([])

  useEffect(() => {
    d3.csv<WomenData>(
      `${
        process.env.NODE_ENV === 'production'
          ? 'https://dev-interaktiv-mf.tagesanzeiger.ch/2024/votations-federales-avs'
          : ''
      }/prestations-complementaires.csv`,
      (d) => {
        return {
          age: +d['age'],
          total: +d['total'],
          men: +d['men'],
          women: +d['women'],
        }
      }
    )
      .then((data) => {
        setData(data.filter((d) => d.age > 64))
      })
      .catch((error) => {
        console.error('Error fetching the CSV data:', error)
      })
  }, [])

  const onStepEnter = (stepData: any) => {
    console.log('Enter step', data)
    console.log(stepData)
    setStep(stepData.data)
  }

  return (
    <Scrollyrtelling>
      <StickyChart>
        <ContentWidth>
          <>
            {process.env.NODE_ENV !== 'production' && (
              <div style={{ position: 'fixed', top: 0, left: 0 }}>[{step}]</div>
            )}
            <PcChart data={data} step={step} />
          </>
        </ContentWidth>
        <TextWidth>
          <Small>
            <strong>Source</strong>: Office fédéral des assurances sociales,
            décembre 2022
          </Small>
        </TextWidth>
      </StickyChart>
      <ScrollytellingContainer>
        <Scrollama offset={1} onStepEnter={onStepEnter} on>
          <Step data={0} key={`scrollama-step-${0}`}>
            <StepContainer style={{ height: '25vh' }} />
          </Step>
          <Step data={1} key={`scrollama-step-${1}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Dans toutes les classes d’âge, les femmes sont plus nombreuses
                  à recourir aux prestations complémentaires à l'AVS que les
                  hommes.
                </p>
                <p>
                  Et <Strong>l’écart</Strong> se creuse avec l’âge.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={2} key={`scrollama-step-${2}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Cette différence s'explique en partie par le patrimoine moins
                  élevé des femmes à la retraite. Celui-ci ne suffit pas à
                  compenser la baisse de revenus après 65 ans.
                </p>
                <p>
                  Les femmes sont également presque deux fois plus nombreuses
                  que les hommes à vivre en home à partir de 80 ans.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
          <Step data={3} key={`scrollama-step-${3}`}>
            <StepContainer>
              <StepContent>
                <p>
                  Toutefois, ce graphique ne montre pas la part de retraités qui renoncent
                  aux prestations complémentaires.
                </p>
                <p>
                  Ce cas concernerait près de <Strong>20% de femmes et 11% d'hommes</Strong>.
                </p>
              </StepContent>
            </StepContainer>
          </Step>
        </Scrollama>
      </ScrollytellingContainer>
    </Scrollyrtelling>
  )
}

const StickyChart = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
`

const Scrollyrtelling = styled.div`
  margin-bottom: 60px;
`

const ScrollytellingContainer = styled.div`
  position: relative;
  width: 100%;
  pointer-events: none;
  margin-top: -120vh;
`

const StepContainer = styled.div`
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding-bottom: 100vh;
`

const StepContent = styled.div`
  max-width: 300px;
  padding: 15px;
  background: ${({ theme }) => theme.backgroundColor};
  line-height: 1.5;
  font-family: var(--font-serif);
  font-size: 0.95em;
  -webkit-font-smoothing: antialiased;

  ${({ theme }) => theme.breakpoints.up('xxxl')} {
    transform: translateX(-100%);
  }

  p:first-child {
    margin-top: 0;
  }
`

const SliderContent = styled.div`
  width: 400px;
`

const InlinePct = styled.strong`
  color: ${({ theme }) => `rgb(${theme.mainColor})`};
  background: ${({ theme }) => `rgb(${theme.mainColor}, 0.2)`};
  padding: 0 0.25em;
  position: relative;
  font-family: var(--font-sans-serif);
`

const InlinePctBar = styled.span`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  height: 100%;
  background: ${({ theme }) => `rgb(${theme.mainColor})`};
`

const SliderContainer = styled.div`
  display: flex;
  justify-content: center;
`

const YearTitle = styled.div`
  font-size: 0.75em;
  text-align: center;
  font-weight: 200;
  text-transform: uppercase;
  opacity: 0.5;
  margin-bottom: 0.5em;
  letter-spacing: 0.1em;
`

const Year = styled.div`
  font-size: 3em;
  text-align: center;
  font-weight: bold;
  margin-bottom: 0.5em;
  color: ${({ theme }) => `rgb(${theme.mainColor})`};
`

const Strong = styled.strong`
  color: ${({ theme }) => `rgb(${theme.mainColor})`};
  font-family: var(--font-sans-serif);
  background: ${({ theme }) => `rgb(${theme.mainColor}, 0.2)`};
`

export default WomenChart
